"use client";

import { useTranslation } from "react-i18next";
import { MobileMenu } from "@/data/types";
import Image from "next/image";
import travelAgentsIcon from "@/images/icons/travel_agents.svg";
import recruitmentIcon from "@/images/icons/recruitment.svg";

export const usePartnersMenu = (): MobileMenu[] => {
    const { t } = useTranslation("guydeez");

    return [
        { 
            href: "/travel-agents",
            name: t("travel_agents"), 
            description: t("travel_agents_description"), 
            icon: () => <Image src={travelAgentsIcon} alt={t("travel_agents")} width={24} height={24} /> 
        },
        {
            // → public "Devenir guide" marketing landing; its CTA then sends
            //   the visitor into the /recruitment signup wizard.
            href: "/becoming-guide",
            name: t("recruitment"),
            description: t("recruitment_description"),
            icon: () => <Image src={recruitmentIcon} alt={t("recruitment")} width={24} height={24} />
        },
    ];
};